import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const CircleWithChordsComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { centerX = 200, centerY = 150, radius = 90, pointA_angle = 30, pointB_angle = 120, pointC_angle = 210, pointD_angle = 300, pointE_angle = 0, circleColor = "black", chordColor = "black", strokeWidth = 2 } = params;
  
  const pointA_x = centerX + radius * Math.cos(pointA_angle * Math.PI / 180);
  const pointA_y = centerY + radius * Math.sin(pointA_angle * Math.PI / 180);
  const pointB_x = centerX + radius * Math.cos(pointB_angle * Math.PI / 180);
  const pointB_y = centerY + radius * Math.sin(pointB_angle * Math.PI / 180);
  const pointC_x = centerX + radius * Math.cos(pointC_angle * Math.PI / 180);
  const pointC_y = centerY + radius * Math.sin(pointC_angle * Math.PI / 180);
  const pointD_x = centerX + radius * Math.cos(pointD_angle * Math.PI / 180);
  const pointD_y = centerY + radius * Math.sin(pointD_angle * Math.PI / 180);
  const pointE_x = centerX + radius * Math.cos(pointE_angle * Math.PI / 180);
  const pointE_y = centerY + radius * Math.sin(pointE_angle * Math.PI / 180);
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <circle 
        cx={centerX} 
        cy={centerY} 
        r={radius} 
        fill="none" 
        stroke={circleColor} 
        strokeWidth={strokeWidth}
      />
      
      <line x1={pointB_x} y1={pointB_y} x2={pointD_x} y2={pointD_y} stroke={chordColor} strokeWidth={strokeWidth}/>
      <line x1={pointA_x} y1={pointA_y} x2={pointC_x} y2={pointC_y} stroke={chordColor} strokeWidth={strokeWidth}/>
      <line x1={pointA_x} y1={pointA_y} x2={pointE_x} y2={pointE_y} stroke={chordColor} strokeWidth={strokeWidth}/>
      <line x1={pointB_x} y1={pointB_y} x2={pointE_x} y2={pointE_y} stroke={chordColor} strokeWidth={strokeWidth}/>
      <line x1={pointC_x} y1={pointC_y} x2={pointD_x} y2={pointD_y} stroke={chordColor} strokeWidth={strokeWidth}/>
      
      <text x={pointA_x - 5} y={pointA_y - 10} fontSize="16" fontWeight="bold">A</text>
      <text x={pointB_x - 20} y={pointB_y - 5} fontSize="16" fontWeight="bold">B</text>
      <text x={pointC_x - 10} y={pointC_y + 20} fontSize="16" fontWeight="bold">C</text>
      <text x={pointD_x + 10} y={pointD_y + 15} fontSize="16" fontWeight="bold">D</text>
      <text x={pointE_x + 10} y={pointE_y - 10} fontSize="16" fontWeight="bold">E</text>
      
      {showCoords && (
        <DraggablePoint 
          cx={centerX} cy={centerY} 
          label="Center" coords={`(${centerX},${centerY})`}
          onDrag={(x, y) => onPointDrag('centerX', x, 'centerY', y)}
          svgRef={svgRef}
        />
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

